import { call, put, takeLatest } from "redux-saga/effects";
import toast from "react-hot-toast";
import * as types from "../actions/actionTypes";
import {
  axiosGet,
  axiosPost,
  axiosPut,
  axiosDelete,
} from "../../utils/common/axios";
import {
  getAllReviewResponse,
  getReviewByIdResponse,
  addReplyToReviewResponse,
  getReviewsByProductIdResponse,
} from "../actions";

export function* createReviewEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosPost(`review`, action.data?.payload)
    );
    action.data?.callback?.success?.(data);
    toast.success(data?.message || "Review saved successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.data?.callback?.failure?.(e);
  }
}

export function* updateReviewEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosPut(`review/${action?.data?.payload?.id}`, action.data?.payload)
    );
    action.data?.callback?.success?.(data);
    toast.success(data?.message || "Review updated successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.data?.callback?.failure?.(e);
  }
}

export function* getAllReviewEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`review/all`));
    yield put(getAllReviewResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getAllReviewResponse([]));
  }
}

export function* getReviewByIdEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`review/2`));
    yield put(getReviewByIdResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getReviewByIdResponse([]));
  }
}

export function* deleteReviewEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosDelete(`review/3`));
    action.payload?.callback?.success?.(data);
    toast.success(data?.message || "Review deleted successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.payload?.callback?.failure?.(e);
  }
}

export function* addReplyToReviewEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosGet(
        `review/reply?id=4&message=Thank you for your feedback!&userId=2`
      )
    );
    yield put(addReplyToReviewResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(addReplyToReviewResponse([]));
  }
}

export function* getReviewsByProductIdEffectSaga(action) {
  const { id, callback } = action.payload;
  try {
    const { data } = yield call(() => axiosGet(`review/product/${id}`));
    yield put(getReviewsByProductIdResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getReviewsByProductIdResponse([]));
  }
}

export function* reviewWatcherSaga() {
  yield takeLatest(types.CREATE_REVIEW, createReviewEffectSaga);
  yield takeLatest(types.UPDATE_REVIEW, updateReviewEffectSaga);
  yield takeLatest(types.GET_ALL_REVIEW, getAllReviewEffectSaga);
  // yield takeLatest(types.GET_REVIEW, getReviewByIdEffectSaga);
  yield takeLatest(types.DELETE_REVIEW, deleteReviewEffectSaga);
  // yield takeLatest(types.GET_REVIEW, addReplyToReviewEffectSaga);
  yield takeLatest(types.GET_REVIEW, getReviewsByProductIdEffectSaga);
}
